import React from "react";
import { Zap } from "lucide-react";
import { BrandMarquee } from "@/components/BrandMarquee";
import { useSiteContent } from "@/context/SiteContentContext";
import { BrandMark } from "@/components/BrandMark";
import { SiteNavLink } from "@/components/SiteNavLink";
import { SITE_CONTAINER } from "@/lib/siteLayout";
import { CookieSettingsLink } from "@/components/CookieConsentBanner";

export const Footer = () => {
  const { content } = useSiteContent();
  const footerLinks = (content.footer?.links || []).filter((l) => l.visible !== false);
  const org = content.brand?.organization_name || "AutoPark";
  const copy = content.footer?.copyright || "Minden jog fenntartva.";

  return (
    <>
      {content.footer?.show_brand_marquee !== false && <BrandMarquee />}
      <footer data-testid="footer" className="border-t border-white/10 py-12 mt-0">
        <div className={`${SITE_CONTAINER} flex flex-col md:flex-row items-center justify-between gap-6`}>
          <div className="flex items-center gap-2">
            <Zap className="w-5 h-5 text-electric" strokeWidth={1.5} />
            <span className="font-heading text-lg font-semibold">
              <BrandMark />
            </span>
          </div>
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} {org}. {copy}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-slate-400">
            {footerLinks.map((l) => (
              <SiteNavLink
                key={`f-${l.path}-${l.label}`}
                link={l}
                testid={l.path === "/admin" ? "footer-admin-link" : undefined}
                className="hover:text-white transition-colors"
              />
            ))}
            <CookieSettingsLink />
          </div>
        </div>
      </footer>
    </>
  );
};
